module.exports = __webpack_public_path__ + "img/IMG_9956.942fae5d.jpeg";